module.exports = __webpack_public_path__ + "img/huizhong.fc35a4d6.png";